import {makeRequest, makeRequestPut, makeRequestGet, apiCP} from '../Services/API';

export function getDadosDashboard(user, lang) {
    return makeRequest(`/backend/dashboard/${user}/${lang}`);
}
// Relatórios Calendário ----------

export function getCategoriasReport(lang) {
    return makeRequestGet(`/backend/categoriasReport/${lang}`);
}
// Relatórios ----------

// Questionários ----------
export function getQuestionarios(indiceI, indiceF, lang, signal, codigo, descricao, cliente, dataInicial, dataFinal, responsavel, negocio, validado) {
    return makeRequestGet(
        `/backend/questionarios/getQuestionarios/${lang}?indiceI=${indiceI}&indiceF=${indiceF}${codigo ? `&codigo=${codigo}` : ''}${descricao ? `&descricao=${descricao}` : ''}${
            cliente ? `&cliente=${cliente}` : ''
        }${dataInicial ? `&dataCriacaoInicial=${dataInicial}` : ''}${dataFinal ? `&dataCriacaoFinal=${dataFinal}` : ''}${responsavel ? `&representante=${responsavel}` : ''}${
            negocio ? `&negocio=${negocio}` : ''
        }${validado ? `&validado=${validado}` : ''}`,
        signal,
    );
}

export function getQuestionarioData(idRecebido, lang) {
    return makeRequestGet(`/backend/questionarios/getQuestionario/${lang}/${idRecebido}`);
}

export function enviarQuestionario(bodyParameters, lang) {
    return makeRequest(`/backend/questionarios/GuardarQuestionario/${lang}`, bodyParameters);
}

export function finalizarQuestionario(id, lang) {
    return makeRequest(`/backend/questionarios/finalizarQuestionario/${lang}/${id}`);
}

// -------------------

export function getClientes(indiceI, indiceF, lang) {
    let params = {
        indiceI: indiceI,
        indiceF: indiceF,
    };

    return makeRequest(`/backend/clientes/${lang}`, params);
}

// ------------------- Dashboard

export function getCarteirasContas(lang) {
    return makeRequestGet(`/backend/dashboard/carteirasContas/${lang}`);
}

export function getLeadsFollowUp(lang, indiceI, indiceF) {
    return makeRequestGet(`/backend/dashboard/leadsFollowUp/${lang}/${indiceI}/${indiceF}`);
}

export function getLeadsProspects(lang) {
    return makeRequestGet(`/backend/dashboard/leadsProspects/${lang}`);
}

export function getClientesProspects(lang) {
    return makeRequestGet(`/backend/dashboard/clientesProspects/${lang}`);
}

export function getPaisAtual(lang) {
    return makeRequestGet(`/backend/prospects/${lang}/GetPaisUser`);
}

export function getClientesConquistar(lang) {
    return makeRequestGet(`/backend/dashboard/clientesConquistar/${lang}`);
}

export function getAniversarios(lang, indiceI, indiceF) {
    return makeRequestGet(`/backend/dashboard/aniversarios/${lang}/${indiceI}/${indiceF}`);
}

export function getStatusOrcamentos(lang, indiceI, indiceF) {
    return makeRequestGet(`/backend/dashboard/statusOrcamentos/${lang}/${indiceI}/${indiceF}`);
}

export function getFaturacaoAnual(lang) {
    return makeRequestGet(`/backend/dashboard/faturacaoAnual/${lang}`);
}

export function getTopClientesUmAno(lang) {
    return makeRequestGet(`/backend/dashboard/topClientesUmAno/${lang}`);
}

export function getTopClientesCincoAnos(lang) {
    return makeRequestGet(`/backend/dashboard/topClientesCincoAnos/${lang}`);
}

// -------------------
export function getPdf(id, vcrtyp) {
    return makeRequestGet(`/backend/getPdfDoc?id=${id}&vcrtyp=${vcrtyp}`);
}

export function getStatusNegocio(language) {
    return makeRequestGet(`/backend/negocio/getStatus/${language}`);
}
export function getStatusOrcamento(language) {
    return makeRequestGet(`/backend/negocio/getStatus/${language}`);
}
export function getPrazosEntrega(language) {
    return makeRequestGet(`/backend/negocio/getPrazosEntrega/${language}`);
}
export function getValidadesProposta(language) {
    return makeRequestGet(`/backend/negocio/getValidadesProposta/${language}`);
}
export function getPontosAnalise(language) {
    return makeRequestGet(`/backend/negocio/getPontosAnalise/${language}`);
}
export function getNegocios(
    indiceI,
    indiceF,
    lang = 'POR',
    signal,
    kanban,
    consulta,
    filtroEstado,
    filtroRep,
    filtroPotencial,
    filtroNome,
    filtroEtapa,
    filtroEmpresa,
    filtroDtIni,
    filtroDtFim,

    filtroValor,
    filtroCodigo,

    filtroCategoria,
    filtroMarca,
    filtroNacionalInternacional,
    filtroFamilia,
    filtroStatusInicialDt,
    filtroStatusFinalDt,
) {
    return makeRequestGet(
        `/backend/negocios/${lang}?indiceI=${indiceI}&indiceF=${indiceF}&kanban=${kanban}&consulta=${consulta}${filtroRep
            ?.map(r => '&Representante=' + r.value)
            .reduce(
                (a1, a2) => a1 + a2,
                '',
            )}&Estado=${filtroEstado}&Potencial=${filtroPotencial}&Categoria=${filtroCategoria}&Marca=${filtroMarca}&NacInternac=${filtroNacionalInternacional}&Familia=${filtroFamilia}&Nome=${filtroNome}${filtroEtapa
            ?.map(r => '&Etapa=' + r.value)
            .reduce(
                (a1, a2) => a1 + a2,
                '',
            )}&Cliente=${filtroEmpresa}&dataInicial=${filtroDtIni}&dataFinal=${filtroDtFim}&DataStatusInicial=${filtroStatusInicialDt}&DataStatusFinal=${filtroStatusFinalDt}&Valor=${
            filtroValor ?? 0
        }&Codigo=${filtroCodigo}`,
        signal,
    );
}
export function getRelatorios(
    indiceI,
    indiceF,
    lang = 'POR',
    signal,
    filtroCodigo,
    filtroData,
    filtroNegocio,
    filtroGestorCliente,
    filtroMarca,
    filtroCliente,
    filtroObs,
    filtroMotivo,
    filtroValor,
    filtroConcorrencia,
    filtroMarcaModelo,
) {
    return makeRequestGet(
        `/backend/negocios/relatorioPerdidos${lang}?indiceI=${indiceI}&indiceF=${indiceF}${filtroGestorCliente
            ?.map(r => '&Representante=' + r.value)
            .reduce(
                (a1, a2) => a1 + a2,
                '',
            )}&Marca=${filtroMarca}&Nome=${filtroNegocio}&Observacoes=${filtroObs}&Motivo=${filtroMotivo}&Concorrencia=${filtroConcorrencia}&MarcaModelo=${filtroMarcaModelo}&Cliente=${filtroCliente}&dataInicial=${filtroData}&Valor=${filtroValor}&Codigo=${filtroCodigo}`,
        signal,
    );
}

export function getNegociosPorId(num, lang = 'POR') {
    let params = {
        id: num,
    };

    return makeRequest(`/backend/negocio/empresa/${lang}`, params);
}

export function enviarEmailOrcamento(idProposta, lang, assunto, corpo, emails) {
    var body = {
        assunto,
        corpo,
        email: emails,
    };
    return makeRequest(`/backend/orcamento/enviarEmailOrcamento/${encodeURIComponent(idProposta)}/${lang}`, body);
}

export function getHistoricoOrcamento(
    indiceI,
    indiceF,
    lang = 'POR',
    signal,
    orcamento,

    filtroDt,
    filtroUtilizador,
    filtroAcao,
    filtroDestinatarios,
    filtroEmail,
) {
    return makeRequestGet(
        `/backend/proposta/getHistoriocOrcamento/${encodeURIComponent(
            orcamento,
        )}/${lang}?indiceI=${indiceI}&indiceF=${indiceF}&data=${filtroDt}&utilizador=${filtroUtilizador}&acao=${filtroAcao}&destinararios=${filtroDestinatarios}&email=${filtroEmail}`,
        signal,
    );
}

export function assinarOrcamento(idProposta, lang) {
    return makeRequest(`/backend/orcamento/assinar/${lang}`, idProposta);
}

export function encomendarOrcamento(idProposta, lang) {
    return makeRequest(`/backend/orcamento/encomendar/${lang}`, idProposta);
}
export function aprovarOrcamento(idProposta, aprovado, justificacao, lang) {
    let params = {
        id: idProposta,
        aprovado,
        justificacao,
    };
    return makeRequest(`/backend/orcamento/aprovarOrcamento/${lang}`, params);
}
// export function criarEncomendaVenda(estabelecimento, cliente, artigos, ax5, lang) {
//     const params = {
//         estabelecimento: estabelecimento,
//         cliente: cliente,
//         artigos: artigos,
//         ax5: ax5,
//     };

//     return makeRequest(`/backend/orcamento/encomendaVenda/${lang}`, params);
// }

export function postEtapas(num, data, etapa, motivo, terminoProjeto, lang = 'POR') {
    let params = [
        {
            num: num,
            data: data,
            etapa: etapa,
            motivo: motivo,
            terminoProjeto: terminoProjeto,
        },
    ];

    return makeRequest(`/backend/negocios/etapa/${lang}`, params);
}

export function getProspects(
    indiceI,
    indiceF,
    lang,

    nome,
    nif,
    cidade,
    pais,
    representante,
    signal,
) {
    let params = {
        indiceI: indiceI,
        indiceF: indiceF,
        nome: nome,
        nif: nif,
        cidade: cidade,
        pais: pais,
        representante: representante,
    };
    return makeRequest(`/backend/prospects/${lang}`, params, signal);
}

export function getCategorias(lang) {
    return makeRequestGet(`/backend/prospects/getCategorias/${lang}`);
}
export function getPropostas(indiceI, indiceF, lang, signal, codigo = '', tipo = '', dataInicial = '', dataFinal = '', cliente = '', negocio = '', representantes = [], estado, filtroEncomenda) {
    return makeRequestGet(
        `/backend/getPropostas/${lang}?IndiceI=${indiceI}&IndiceF=${indiceF}${codigo ? '&codigo=' + codigo : ''}${tipo ? '&tipo=' + tipo : ''}${dataInicial ? '&dataInicial=' + dataInicial : ''}${
            dataFinal ? '&dataFinal=' + dataFinal : ''
        }${cliente ? '&cliente=' + cliente : ''}${negocio ? '&negocio=' + negocio : ''}${representantes.map(rep => '&representante=' + rep.value).reduce((a1, a2) => a1 + a2, '')}${
            estado ? '&estado=' + estado : ''
        }${
            filtroEncomenda ? '&transformadoEncomenda=' + filtroEncomenda : ''
        }`,
        signal,
    );
}

export function postProposta(
    lang = 'POR',
    idRecebido,
    estabelecimentoVenda,
    estabelecimentoExpedicao,
    tipoOrcamento,
    referencia,
    cliente,
    estado,
    data,
    // area, //AX5
    // mercado, //AX7
    condicoesPagamento,
    descricaoOutros,
    representante,
    negocio,
    moeda,
    lingua,

    layout,
    textoIntroducao,
    textoDespedida,
    prazoEntrega,
    localEntrega,
    validadeProposta,
    contactoAssinatura,
    // imagemProduto,
    observacoes,
    acresceIVA,
    ecovalor,
    ecolub,
    ecobat,

    garantia,
    garantiaPowerTrain,
    garantiaMotor,

    tipoContrato,
    lubrificantes,
    duracaoContrato,
    horasAno,
    precoHora,

    contactos,
    linhas,
    linhasRetoma,
    pontosAnalise,

    propostaAnterior = '',

    condicoesPagamentoCF,
    duracao,
    carencia,
    numRendas,
    portesMes,
    seguroCivil,
    taxaNominal,
    entradaInicial,
    rendaMensal,
    valorResidual,
    seguroCasco,
    despesasContrato,
) {
    let params = {
        id: idRecebido,
        estabelecimentoVenda,
        estabelecimentoExpedicao,
        tipoOrcamento,
        referencia,
        cliente,
        estado,
        data,
        // area,
        // mercado,
        condicoesPagamento,
        descricaoOutros,
        representante,
        negocio,
        moeda,
        lingua,

        layout,
        textoIntroducao,
        textoDespedida,
        prazoEntrega,
        localEntrega,
        validadeProposta,
        contactoAssinatura,
        // imagemProduto,
        observacoes,
        acresceIVA,
        ecovalor,
        ecolub,
        ecobat,

        garantia,
        garantiaPowerTrain,
        garantiaMotor,

        tipoContrato,
        lubrificantes,
        duracaoContrato,
        horasAno,
        precoHora,

        contactos,

        linhas,
        linhasRetoma,
        pontosAnalise,
        propostaAnterior,

        contratoFinanceiroDuracao: duracao,
        contratoFinanceiroCarencia: carencia,
        contratoFinanceiroNRendas: numRendas,
        contratoFinanceiroPortes: portesMes,
        contratoFinanceiroSegRepCivil: seguroCivil,
        contratoFinanceiroTaxaNominal: taxaNominal,
        contratoFinanceiroEntradaInicial: entradaInicial,
        contratoFinanceiroRendaMensal: rendaMensal,
        contratoFinanceiroValorResidual: valorResidual,
        contratoFinanceiroSeguroCasco: seguroCasco,
        contratoFinanceiroDespesasContrato: despesasContrato,
    };

    return makeRequest(`/backend/GuardarProposta/${lang}`, params);
}

export function gerarRevisao(proposta, lang = 'POR') {
    return makeRequest(`/backend/gerarRevisao/${lang}`, proposta);
}

export function postLinhas(id, nome, referencia, quantidade, preco, desconto, total, lang = 'POR') {
    let params = [
        {
            idLinha: id,
            nome: nome.value,
            referencia: referencia,
            quantidade: parseInt(quantidade),
            preco: parseInt(preco),
            iva: 0,
            desconto: parseInt(desconto),
            total: parseInt(total),
            totalPVP: 0,
        },
    ];
    return makeRequest(`/backend/linhasproposta/${lang}/Criar`, params);
}

export function getMecanicos(lang = 'POR') {
    return makeRequest(`/backend/mecanicos/${lang}`);
}

export function postNegocio(
    num,
    denominacao,
    responsavel,
    valor,
    datafecho,

    etapa,
    // motivoEtapa,
    motivoPerda,

    cliente,

    industria,
    probabilidade,

    // subtipo,
    estabelecimento,
    divisa,

    concorrentes,
    artigos,

    origem,
    observacoes,
    //categoria,
    estado,
    contactos,

    contratoManutencao,
    contratoFinanceiro,

    tipoContrato,
    lubrificantes,
    duracaoContrato,
    horasAno,
    localTrabalho,
    urgente,
    hotDeal,
    condicoesPagamento,
    duracao,
    carencia,
    numRendas,
    portesMes,
    seguroCivil,
    taxaNominal,
    entradaInicial,
    rendaMensal,
    valorResidual,
    seguroCasco,
    despesasContrato,
    lang = 'POR',
) {
    let params = {
        num,
        nome: denominacao,
        responsavel: responsavel,
        valor: valor,
        dataFecho: datafecho,

        etapa: etapa,
        // motivoEtapa: motivoEtapa,
        motivoPerda: motivoPerda,

        codEmpresa: cliente,

        industria: industria,
        probabilidade,

        // subtipo: subtipo,
        estabelecimento,
        divisa,

        concorrentes: concorrentes,
        artigos: artigos,

        origem,
        observacoes,
        //categoria,
        status: estado,
        contactos: contactos,

        contratoManutencao,
        contratoFinanceiro,

        tipoContrato,
        lubrificantes,
        duracaoContrato,
        horasAno,
        localTrabalho,
        urgente,
        hotDeal,
        condicoesPagamento,
        //Novos campos

        duracao,
        carencia,
        numRendas,
        portesMes,
        seguroCivil,
        taxaNominal,
        entradaInicial,
        rendaMensal,
        valorResidual,
        seguroCasco,
        despesasContrato,
    };
    return makeRequest(`/backend/negocios/guardarNegocio/${lang}`, params);
}

export function getReunioes(user, lang = 'POR') {
    return makeRequestGet(`/backend/negocios/reunioes/${lang}/${user}`);
}

export function postContacto(cliente, contacto, nome, apelido, lang = 'POR') {
    let params = {
        cliente: cliente,
        contacto: contacto,
        nome: nome,
        apelido: apelido,
    };
    return makeRequest(`/backend/negocios/Criar/contactos/${lang}`, params);
}

export function putReuniao(num, cliente, id, descricao, dataInicio, dataFim, horaInicio, horaFim, responsavel, estab, telemovel, categoria, lang = 'POR') {
    let params = [
        {
            id: id,
            num: num,
            cliente: cliente,
            descrição: descricao,
            dataI: dataInicio,
            dataF: dataFim,
            horaInicio: horaInicio,
            horaFim: horaFim,
            responsavel: responsavel,
            estabelecimento: estab,
            telemovel: telemovel,
            categoria: categoria,
        },
    ];
    return makeRequestPut(`/backend/negocios/reunioes/editar/${lang}`, params);
}

export function getDados(lang) {
    return makeRequest(`/backend/negocios/dados/${lang}`);
}

export function getCatalogo(
    indiceI,
    indiceF,
    lang,
    signal,
    filtroReferencia = '',
    filtroCategoria = [],
    filtroMarca = [],
    filtroNacionalInternacional = [],
    filtroTipo = [],
    filtroModelo = [],
    filtroVersao = [],
) {
    return makeRequestGet(
        `/backend/catalogo/${lang}?indiceI=${indiceI}&indiceF=${indiceF}&pesquisa=${filtroReferencia}${filtroCategoria.map(f => '&categoria=' + f).reduce((a1, a2) => a1 + a2, '')}${filtroMarca
            .map(f => '&marca=' + f)
            .reduce((a1, a2) => a1 + a2, '')}${filtroNacionalInternacional.map(f => '&nacionalInternacional=' + f).reduce((a1, a2) => a1 + a2, '')}${filtroTipo
            .map(f => '&tipo=' + f)
            .reduce((a1, a2) => a1 + a2, '')}${filtroModelo.map(f => '&modelo=' + f).reduce((a1, a2) => a1 + a2, '')}${filtroVersao.map(f => '&versao=' + f).reduce((a1, a2) => a1 + a2, '')}`,
        signal,
    );
}

export function getExtras(
    indiceI,
    indiceF,
    lang,
    signal,
    filtroReferencia = '',
    filtroCategoria = [],
    filtroMarca = [],
    filtroNacionalInternacional = [],
    filtroTipo = [],
    filtroModelo = [],
    filtroVersao = [],
) {
    return makeRequestGet(
        `/backend/catalogo/getExtras/${lang}?indiceI=${indiceI}&indiceF=${indiceF}&pesquisa=${filtroReferencia}${filtroCategoria
            .map(f => '&categoria=' + f)
            .reduce((a1, a2) => a1 + a2, '')}${filtroMarca.map(f => '&marca=' + f).reduce((a1, a2) => a1 + a2, '')}${filtroNacionalInternacional
            .map(f => '&nacionalInternacional=' + f)
            .reduce((a1, a2) => a1 + a2, '')}${filtroTipo.map(f => '&tipo=' + f).reduce((a1, a2) => a1 + a2, '')}${filtroModelo.map(f => '&modelo=' + f).reduce((a1, a2) => a1 + a2, '')}${filtroVersao
            .map(f => '&versao=' + f)
            .reduce((a1, a2) => a1 + a2, '')}`,
        signal,
    );
}

export function getContactosId() {
    return makeRequestGet(`/backend/prospects/GetCodigoContacto`);
}

export function PostDadosContaPesquisa(pesquisa, lang = 'POR') {
    let params = [
        {
            pesquisa: pesquisa,
        },
    ];
    return makeRequest(`/backend/negocios/conta/${lang}`, params);
}

export function getNegociosId(idRecebido, lang) {
    let params = [
        {
            id: idRecebido,
            lang: lang,
        },
    ];
    return makeRequestGet(`/backend/getnegocio/${lang}?id=${idRecebido}`);
}

export function getPropostaId(idRecebido, lang) {
    return makeRequestGet(`/backend/getProposta/${lang}?id=${idRecebido}`);
}

export function getReuniaoId(idRecebido, lang = 'POR') {
    let params = [
        {
            id: idRecebido,
        },
    ];
    return makeRequest(`/backend/negocios/reunioesID/${lang}`, params);
}

export function getClienteId(idRecebido, lang) {
    let params = {
        id: idRecebido,
    };

    return makeRequest(`/backend/clienteID/${lang}`, params);
}

export function putCliente(id, nome, nif, pais, lingua, divisa, enderecos, categoria, resp, origem, lang = 'POR') {
    let params = {
        codigoCliente: id,
        nomeCliente: nome,
        contribuinte: nif,
        pais: pais,
        lingua: lingua,
        divisa: divisa,
        enderecos: enderecos,
        categoria: categoria,
        resp: resp,
        origem: origem,
    };
    return makeRequestPut(`/backend/clientes/atualizar/${lang}`, params);
}

export function getClientesPesquisa(pesquisa, indiceI, indiceF, lang) {
    let params = {
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/clientes/pesquisa/${lang}`, params);
}

export function getClientesFiltros(pesquisa, indiceI, indiceF, lang) {
    let params = {
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/clientes/filtros/${lang}`, params);
}

export function getDadosAX(lang = 'POR') {
    return makeRequestGet(`/backend/cliente/dadosAX/${lang}`);
}

export function postCliente(nome, nif, categoria, morada, codPostal, cidade, contacto, email, pais, moeda, lingua, responsavel, ax6, ax7, lang = 'POR') {
    let params = {
        nomeCliente: nome,
        contribuinte: nif,
        categoria: categoria,
        morada: morada,
        codPostal: codPostal,
        cidade: cidade,
        contacto: contacto,
        email: email,
        paisId: pais,
        moedaId: moeda,
        linguaId: lingua,
        representante: responsavel,
        ax6: ax6,
        ax7: ax7,
    };
    return makeRequest(`/backend/clientes/Criar/${lang}`, params);
}

export function getProspectId(idRecebido, lang) {
    return makeRequestGet(`/backend/GetProspect/${lang}?id=${idRecebido}`);
}

export function postProspect(
    id,
    nome,
    nif,
    categoria,
    enderecos,
    pais,
    divisa,
    lingua,
    resp,
    origem,
    contactos,
    // utilizador,
    tipoCliente,
    // codFinalidade,
    // catContacto,

    actividade,
    equipamentoOutrasMarcas,
    lang = 'POR',
) {
    var end = enderecos.filter(e => e.id != '');

    let params = {
        codigoCliente: id,
        nomeCliente: nome,
        contribuinte: nif,
        //"descricaoCurta": "string",
        categoria: categoria,
        //"categoriaDescricao": "string",
        //"sigla": "string",
        pais: pais,
        lingua: lingua,
        divisa: divisa,
        origem: origem,
        responsavel: resp,
        tipoCliente: tipoCliente,
        enderecos: end,
        contactos: contactos,
        actividade,
        equipamentoOutrasMarcas: equipamentoOutrasMarcas,
    };

    return makeRequest(`/backend/prospects/Guardar/${lang}`, params);
}

export function postInformacoesProposta(
    id,
    utilizador,
    layout,
    foto,
    texto,
    prazo,
    local,
    validade,
    obs,
    contactoAssinatura,
    imagemA,
    fornecimento,
    taxa1,
    taxa2,
    taxa3,
    pagamento,
    garantia,
    garantiaPT,
    garantiaM,
    contrato,
    lubrificantes,
    duracao,
    horasAno,
    precoHora,
    lang,
) {
    let params = {
        id: id,
        user: utilizador,
        layout: layout,
        claim: foto,
        despedida: texto,
        prazo: prazo,
        local: local,
        validade: validade,
        obs: obs,
        contactoAss: contactoAssinatura,
        imagemA: 0,
        fornecimento: fornecimento,
        taxa1: taxa1,
        taxa2: taxa2,
        taxa3: taxa3,
        pagamento: pagamento,
        garantia: garantia,
        garantiaPT: garantiaPT,
        garantiaM: garantiaM,
        contrato: contrato,
        lubrificantes: lubrificantes,
        duracao: duracao,
        horasAno: horasAno,
        precoHora: precoHora,
    };
    return makeRequest(`/backend/proposta/informacoes/${lang}`, params);
}

export function getInformacaoProposta(id, lang) {
    let params = {
        id: id,
    };

    return makeRequest(`/backend/proposta/informacoesProposta/${lang}`, params);
}

export function getInfoArtigoPopup(id, indexOfFirstItem, indexOfLastItem, lang) {
    return makeRequestGet(`/backend/catalogo/getCatalogoInfo/${lang}/${id}`);
}

export function getEstabelecimentos(lang = 'POR') {
    return makeRequestGet(`/backend/getEstabelecimentos/${lang}`);
}

export function getCategoriasArtigos(lang = 'POR') {
    return makeRequestGet(`/backend/getCategoriasArtigos/${lang}`);
}
export function getOficinas(lang = 'POR') {
    return makeRequestGet(`/backend/oficinas/${lang}`);
}

export function getSubtipos(lang = 'POR') {
    return makeRequestGet(`/backend/negocios/subtipos/${lang}`);
}

export function getEstadosProposta(lang) {
    return makeRequest(`/backend/proposta/getEstadosProposta/${lang}`);
}
export function getTiposPropostas(lang) {
    return makeRequest(`/backend/proposta/getTiposPropostas/${lang}`);
}

export function getContactos(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/negocios/contactos/${lang}`, params);
}

export function getVisitas(
    indiceI,
    indiceF,
    lang,
    signal,
    inicio = '',
    fim = '',
    cliente = '',
    negocio = '',
    estabelecimento = '',
    representante = [],
    categoria = [],
    descricao = '',
    codigo = '',
    calendario = false,
) {
    return makeRequestGet(
        `/backend/visitas/${lang}?indiceI=${indiceI}&indiceF=${indiceF}&inicio=${inicio}&fim=${fim}&cliente=${cliente}&negocio=${negocio}&estabelecimento=${estabelecimento}${representante
            .map(r => `&representante=${r}`)
            .reduce((a1, a2) => a1 + a2, '')}${categoria.map(c => `&categoria=${c}`).reduce((a1, a2) => a1 + a2, '')}&descricao=${descricao}&codigo=${codigo}&calendario=${calendario}`,
        signal,
    );
}

export function postUpdateVisita(id, repnum, lang, date) {
    // let params = {
    //   user: user,
    //   pesquisa: pesquisa,
    //   indiceI: indiceI,
    //   indiceF: indiceF,
    // };
    return makeRequest(`/backend/UpdateVisita/${id}/${repnum}/${lang}?data=${date}`);
}

export function getVisitasFiltros(user, pesquisa, indiceI, indiceF, lang) {
    let params = {
        user: user,
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/visitas/filtros/${lang}`, params);
}

export function getAcessoriosPropostas(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/proposta/acessorios/${lang}`, params);
}

export function postAcessoriosPropostas(id, acessorio, preco, lang = 'POR') {
    let params = {
        id: id,
        nome: acessorio,
        preço: preco,
    };
    return makeRequest(`/backend/proposta/acessorios/Criar/${lang}`, params);
}

export function deleteAcessorios(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/proposta/acessorios/delete/${lang}`, params);
}

export function getAtributos(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/proposta/atributos/artigo/${lang}`, params);
}

export function getAtributosP(id, ref, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
    };
    return makeRequest(`/backend/proposta/atributos/proposta/${lang}`, params);
}

export function postAtributos(id, ref, linha, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
        linha: linha,
    };
    return makeRequest(`/backend/proposta/atributos/proposta/Criar/${lang}`, params);
}

export function eliminarAtributos(id, ref, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
    };
    return makeRequest(`/backend/proposta/atributos/proposta/delete/${lang}`, params);
}

export function getAcessoriosPropostaArtigo(id, ref, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
    };
    return makeRequest(`/backend/proposta/acessoriosP/${lang}`, params);
}

export function getAcessoriosProposta(id, lang = 'POR') {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/propostaAcessorios/${lang}`, params);
}

export function postAcessoriosPropostaArtigo(id, ref, linha, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
        linha: linha,
        quantidade: 0,
        preço: 0,
        desc: 0,
        total: 0,
    };
    return makeRequest(`/backend/proposta/acessoriosP/Criar/${lang}`, params);
}

export function postAcessoriosPropostaArtigo2(id, ref, linha, qtd, preco, desc, total, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
        linha: linha,
        quantidade: parseInt(qtd),
        preço: parseFloat(preco),
        desc: parseFloat(desc),
        total: parseFloat(total),
    };
    return makeRequest(`/backend/proposta/acessoriosP/Criar/${lang}`, params);
}

export function deleteAcessoriosPropostaArtigo(id, ref, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
    };
    return makeRequest(`/backend/proposta/acessoriosP/delete/${lang}`, params);
}

export function alterarAcessoriosPropostaArtigo(id, ref, linha, quantidade, preço, desc, total, lang = 'POR') {
    let params = {
        id: id,
        ref: ref,
        linha: linha,
        quantidade: parseInt(quantidade),
        preço: parseFloat(preço),
        desc: parseFloat(desc),
        total: parseFloat(total),
    };
    return makeRequest(`/backend/proposta/acessoriosP/update/${lang}`, params);
}

export function getCategoriasReunioes(lang) {
    return makeRequest(`/backend/reunioes/getCategorias/${lang}`);
}

export function getValidaNif(nif, lang = 'POR') {
    const params = {
        id: nif,
    };
    return makeRequest(`/backend/verificaNif/${lang}`, params);
}

export function getNifContacto(num, lang = 'POR') {
    const params = {
        id: num,
    };
    return makeRequest(`/backend/nifContacto/${lang}`, params);
}

export function getDadosProposta(lang) {
    return makeRequest(`/backend/orcamento/dados/${lang}`);
}

export function criarOrcamento(estabVenda, tipoOrcamento, data, cliente, estabExp, rep, artigos, ax5, ax7, projeto, lang = 'POR') {
    let params = {
        estabelecimentoVenda: estabVenda,
        tipoOrcamento: tipoOrcamento,
        data: data,
        cliente: cliente,
        estabelecimentoExpedicao: estabExp,
        representante: rep,
        artigos: artigos,
        aX5: ax5,
        aX7: ax7,
        projeto: projeto,
    };
    return makeRequest(`/backend/orcamento/Criar/${lang}`, params);
}

export function putOrcamento(idProposta, estabVenda, tipoOrcamento, data, cliente, estabExp, rep, artigos, ax5, ax7, projeto, lang = 'POR') {
    let params = {
        idProposta: idProposta,
        estabelecimentoVenda: estabVenda,
        tipoOrcamento: tipoOrcamento,
        data: data,
        cliente: cliente,
        estabelecimentoExpedicao: estabExp,
        representante: rep,
        artigos: artigos,
        aX5: ax5,
        aX7: ax7,
        projeto: projeto,
    };
    return makeRequest(`/backend/orcamento/Alterar/${lang}`, params);
}

export function eliminaLinhaOrcamento(id, linha, lang = 'POR') {
    const params = {
        linha: linha,
        id: id,
    };
    return makeRequest(`/backend/orcamento/elimina/${lang}`, params);
}

export function atualizaDadosOrcamento(idOriginal, idFinal, lang = 'POR') {
    const params = {
        numOriginal: idOriginal,
        numFinal: idFinal,
    };
    return makeRequest(`/backend/orcamento/Versoes/${lang}`, params);
}

export function atualizaDadosOrcamentoAposCriar(id, lang = 'POR') {
    const params = {
        id: id,
    };
    return makeRequest(`/backend/orcamento/atualizarCriar/${lang}`, params);
}

export function adjudicarOrcamento(idOriginal, idFinal, lang = 'POR') {
    const params = {
        numOriginal: idOriginal,
        numFinal: idFinal,
    };
    return makeRequest(`/backend/orcamento/adjudicar/${lang}`, params);
}

export function getEmail(id, lang = 'POR') {
    const params = {
        id: id,
    };
    return makeRequest(`/backend/propostaAcessorios/email/${lang}`, params);
}

export function putDadosOS(num, dataInicio, dataFim, utilizador, mecanico, lang = 'POR') {
    const params = {
        numPedido: num,
        dataInicio: dataInicio,
        dataFim: dataFim,
        utilizador: utilizador,
        mecanico: mecanico,
    };
    return makeRequest(`/backend/alteraDados/${lang}`, params);
}

export function getFuncoesContactos(lang) {
    return makeRequest(`/backend/prospects/funcoes/${lang}`);
}

export function postContactosProspect(num, contactos, lang = 'POR') {
    var cont = contactos
        .filter(e => e.id != '')
        .map(e => {
            e.funcao = e.funcao?.value;
            e.cpd = e.contactoDefeito ? '2' : '1';
            return e;
        });

    return makeRequest(`/backend/prospects/contactos/${num}/${lang}`, cont);
}

export function getAnexosEquipamento(equipamento) {
    return makeRequestGet(`/backend/prospects/GetAnexosEquipamento?macnum=${equipamento}`);
}

export function getAnexosCatalogo(artigo) {
    return makeRequestGet(`/backend/catalogo/GetAnexosCatalogo?itmref=${artigo}`);
}
export function getAnexo(abrev, ident1, ident2, ident3) {
    return makeRequestGet(`/backend/GetAnexo?abrev=${abrev}&ident1=${ident1}&ident2=${ident2}&ident3=${ident3}`);
}

export function getContactosProspect(num, lang) {
    return makeRequestGet(`/backend/contactosCliente/${num}/${lang}`);
}

export function getProdutosVendidos(num, lang, signal, indiceI, indiceF, referencia = '', descricao = '', quantidade = 0, preco = 0, docNum = '', data = null, precoTotal = 0, equipamentos = true) {
    return makeRequestGet(
        `/backend/prospects/getProdutosVendidos/${num}/${lang}?indiceI=${indiceI}&indiceF=${indiceF}&referencia=${referencia}&descricao=${descricao}&quantidade=${quantidade}&preco=${preco}&docNum=${docNum}${
            data ? `&data=${data}` : ''
        }&precoTotal=${precoTotal}&equipamentos=${equipamentos}`,
        signal,
    );
}
export function getMaquinas(num, lang, signal, indiceI, indiceF, nEquipamento, descricao, nSerie, artigo, marca, nacInternac, familia, modelo, versao) {
    return makeRequestGet(
        `/backend/prospects/getMaquinas/${num}/${lang}?indiceI=${indiceI}&indiceF=${indiceF}&nEquipamento=${nEquipamento}&descricao=${descricao}&nSerie=${nSerie}&artigo=${artigo}&marca=${marca}&nacInternac=${nacInternac}&familia=${familia}&modelo=${modelo}&versao=${versao}`,
        signal,
    );
}

export function postOrcamentoSemEfeito(num, lang = 'POR') {
    const params = {
        id: num,
    };
    return makeRequest(`/backend/orcamento/semEfeito/${lang}`, params);
}

export function getDespesas(utilizador, indiceI, indiceF, lang, filtroCodigo, filtroUtilizador, filtroData, filtroNome, filtroValor, filtroDespesa, filtroEstado) {
    return makeRequestGet(
        `/backend/despesas/${lang}/${utilizador}?Codigo=${filtroCodigo}
        ${filtroUtilizador.map(r => '&Representante=' + r).reduce((a1, a2) => a1 + a2, '')}&Data=${filtroData}&NomeNIF=${filtroNome}&Valor=${filtroValor ?? 0}&TipoDespesa=${filtroDespesa}&Estado=${
            filtroEstado ?? 0
        }&IndiceI=${indiceI}&IndiceF=${indiceF}`,
    );
}

export function getDespesasFiltros(utilizador, utilizadorCriacao, estado, indiceI, indiceF, lang) {
    let params = {
        utilizador: utilizador,
        indiceI: indiceI,
        indiceF: indiceF,
        utilizadorCriacao: utilizadorCriacao,
        estado: estado,
    };
    return makeRequest(`/backend/despesas/filtros/${lang}`, params);
}

export function getDespesasPesquisa(user, pesquisa, indiceI, indiceF, lang) {
    let params = {
        user: user,
        pesquisa: pesquisa,
        indiceI: indiceI,
        indiceF: indiceF,
    };
    return makeRequest(`/backend/despesas/pesquisa/${lang}`, params);
}

export function getDespesaId(id, lang) {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/despesaID/${lang}`, params);
}

export function getAcessos(usr) {
    let params = {
        username: usr,
    };
    return makeRequest(`/backend/api/login/acessos`, params);
}

export function getEnderecosProspects(id, lang) {
    let params = {
        id: id,
    };
    return makeRequest(`/backend/prospects/enderecos/${lang}`, params);
}

export function postupdUsr(utilizador, id, lang = 'POR') {
    let params = {
        id: utilizador,
        lang: id,
    };
    return makeRequest(`/backend/orcamento/updusr/${lang}`, params);
}

export function getContaCorrente(id, lang, signal = null, indiceI, indiceF, representante = '', estebelecimento = '', dataFac = null, valor = 0, moeda = '', docID = '', dataVenc = null, valPend = 0) {
    let params = {
        id: id,
        indiceI,
        indiceF,
        representante,
        estebelecimento,
        dataFac,
        valor,
        moeda,
        docID,
        dataVenc,
        valPend,
    };
    return makeRequest(`/backend/prospects/contaCorrente/${lang}`, params, signal);
}

export function getVaidacaoNifPais(lang, pais) {
    return makeRequestGet(`/backend/nif/${lang}/${pais}`);
}

export function getStatus(lang) {
    return makeRequestGet(`/backend/status/${lang}`);
}

export function putDespesa(id, status, lang = 'POR') {
    let params = {
        id: id,
        status: status,
    };
    return makeRequest(`/backend/putStatus/${lang}`, params);
}

export function enviarEmail(id, email, lang) {
    let params = {
        num: id,
        email: email,
    };
    return makeRequest(`/backend/pdf/${lang}`, params);
}

export function getHistorico(indiceI, indiceF, lang, search) {
    let params = {
        indiceI: indiceI,
        indiceF: indiceF,
        filtro: search,
    };
    return makeRequest(`/backend/ordem_servico/historico/${lang}`, params);
}

export function getUtilizadores(lang) {
    return makeRequestGet(`/backend/utilizadores/${lang}`);
}

export function guardarDespesa(nome, nif, motivo, valor, startDate, baseImage, utilizador, moeda, tipoDespesa, observacoes, terceiros, nomeU) {
    let params = {
        numeroCliente: '',
        nomeCliente: nomeU,
        nomeCurtoCliente: nomeU,
        language: '',
        nomeDesp: nome,
        data: startDate,
        contribuinte: nif,
        motivo: motivo,
        valor: valor,
        tipo: tipoDespesa,
        foto: baseImage,
        base64: '',
        moeda: moeda,
        utilizador: utilizador,
        observacoes: observacoes,
        terceiros: terceiros,
    };
    return makeRequest(`/backend/despesas/POR/CriarWeb`, params);
}

export async function GetTipoDespesaMoedas(lang) {
    const token = localStorage.getItem('token');
    return makeRequest(`/backend/tiposDespesa/${lang}/`, {
        headers: {
            Authorization: `token ${token}`,
        },
    });
}

export function getVIES(countryCode, vatNumber) {
    const params = {
        countryCode: countryCode,
        vatNumber: vatNumber,
    };
    return makeRequest('/backend/despesas/POR/VIES', params);
}

export function getMarcas(lang) {
    return makeRequestGet(`/backend/getMarcas/${lang}`);
}

export function getMarcasConcorrencia(lang) {
    return makeRequestGet(`/backend/getMarcasConcorrencia/${lang}`);
}

export function getNacionaisInternacionais(lang) {
    return makeRequestGet(`/backend/getNacionaisInternacionais/${lang}`);
}
export function getTipos(lang) {
    return makeRequestGet(`/backend/getTipos/${lang}`);
}
export function getModelos(lang) {
    return makeRequestGet(`/backend/getModelos/${lang}`);
}
export function getVersoes(lang) {
    return makeRequestGet(`/backend/getVersoes/${lang}`);
}
export function getPaises(lang) {
    return makeRequestGet(`/backend/getPaises/${lang}`);
}

export function getRepresentantes(lang) {
    return makeRequestGet(`/backend/getRepresentantes/${lang}`);
}
export function getSimNao(lang) {
    return makeRequestGet(`/backend/getSimNao/${lang}`);
}
export function getLinguas(lang) {
    return makeRequestGet(`/backend/getLinguas/${lang}`);
}
export function getMoedas(lang) {
    return makeRequestGet(`/backend/getMoedas/${lang}`);
}

export function getOrigens(language) {
    return makeRequestGet(`/backend/getOrigens/${language}`);
}

export function getTiposContratoManutencao(language) {
    return makeRequestGet(`/backend/getTiposContratoManutencao/${language}`);
}
export function getLubrificantesManutencao(language) {
    return makeRequestGet(`/backend/getLubrificantesManutencao/${language}`);
}
export function getDuracaoContractoManutencao(language) {
    return makeRequestGet(`/backend/getDuracaoContractoManutencao/${language}`);
}
export function getHorasAnoManutencao(language) {
    return makeRequestGet(`/backend/getHorasAnoManutencao/${language}`);
}
export function getAreas(lang) {
    return makeRequestGet(`/backend/getAreas/${lang}`);
}
export function getActividades(lang) {
    return makeRequestGet(`/backend/getActividades/${lang}`);
}

export function getLatituraLongiturFromPostalCode(codPostal) {
    return apiCP.get(`codigo_postal/${codPostal}`);
}

export function getContactoInteresses(lang) {
    return makeRequestGet(`/backend/getContactoInteresses/${lang}`);
}

//-----------------
export function getDuracaoCF(lang) {
    return makeRequestGet(`/backend/negocio/getDuracaoCF/${lang}`);
}
export function getCarenciaCF(lang) {
    return makeRequestGet(`/backend/negocio/getCarenciaCF/${lang}`);
}
export function getNumRendaCF(lang) {
    return makeRequestGet(`/backend/negocio/getNumRendaCF/${lang}`);
}
export function getPortesMesCF(lang) {
    return makeRequestGet(`/backend/negocio/getPortesMesCF/${lang}`);
}
export function getSeguroRespCivilCF(lang) {
    return makeRequestGet(`/backend/negocio/getSeguroRespCivilCF/${lang}`);
}
export function getTaxaNominalCF(lang) {
    return makeRequestGet(`/backend/negocio/getTaxaNominalCF/${lang}`);
}
export function getEntradaInicialCF(lang) {
    return makeRequestGet(`/backend/negocio/getEntradaInicialCF/${lang}`);
}
export function getRendaMensalCF(lang) {
    return makeRequestGet(`/backend/negocio/getRendaMensalCF/${lang}`);
}
export function getValorResidualCF(lang) {
    return makeRequestGet(`/backend/negocio/getValorResidualCF/${lang}`);
}
export function getSeguroCascoMesCF(lang) {
    return makeRequestGet(`/backend/negocio/getSeguroCascoMesCF/${lang}`);
}
export function getDespesaContratoCF(lang) {
    return makeRequestGet(`/backend/negocio/getDespesaContratoCF/${lang}`);
}
export function getPontosMapa(lang) {
    return makeRequestGet(`/backend/getPontosMapa/${lang}`);
}
